import "./public-path";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import userRouter from "./router/userIndex";
import { setupPinia } from "./stores";
import { Button, Tab, Tabs, Form, Field, CellGroup ,Swipe,SwipeItem,Checkbox,Toast,Popup,Collapse, CollapseItem,Overlay} from "vant";
import request from "@/utils/request/index";
import "vant/lib/index.css";
import wx from "weixin-js-sdk-ts";


const app = createApp(App);
app.use(Tab).use(Tabs).use(Form).use(Field).use(CellGroup).use(Button).use(Swipe).use(SwipeItem).use(Checkbox).use(Toast).use(Popup).use(Collapse).use(CollapseItem).use(Overlay);
// app.use(router);
app.use(userRouter);
app.use(setupPinia);
app.config.globalProperties.$http = request;
app.config.globalProperties.$wxsdk = wx;



function render(props: any = {}) {
  const { container } = props;
  app.mount(container ? container.querySelector("#app") : "#app");
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}

/**
 * bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发 bootstrap。
 * 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
 */
export async function bootstrap() {
  console.log("[vue] vue app bootstraped");
}

/**
 * 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
 */
export async function mount(props: any) {
  console.log("[vue] props from main framework", props);
  render(props);
}

/**
 * 应用每次 切出/卸载 会调用的方法，通常在这里我们会卸载微应用的应用实例
 */
export async function unmount() {
  //   app.$destroy();
  //   instance.$el.innerHTML = "";
  //   app = null;
  //   router = null;
}

/**
 * 可选生命周期钩子，仅使用 loadMicroApp 方式加载微应用时生效
 */
export async function update(props: any) {
  console.log("update props", props);
}
